<template>
    <div id="cart">
        <nav-bar class="nav-bar"><div slot="center">购物车</div></nav-bar>
        <cart-list :test="cartList"></cart-list>
        <bottom-bar></bottom-bar>

    </div>
</template>

<script>
    import NavBar from "../../components/common/navbar/NavBar";

    import CartList from "./childComps/CartList";
    import BottomBar from "./childComps/BottomBar";
    export default {
        name: "MallCart",
        components: {
            NavBar,
            CartList,
            BottomBar
        },
        data(){
            return{
                test:'pop',
            }
        },
        mounted() {
        },
        activated(){
            this.$refs.scroll.scroll.refresh();
        },
        computed: {
            cartList() {
                return this.$store.getters.cartList
            },
            cartLength() {
                return this.$store.getters.cartLength
            }
        },
        methods:{
            contentScroll(){
            }
        }
    }
</script>

<style scoped>
    #cart{
        height: 100vh;

    }
    .nav-bar{
        background-color: var(--color-tint);
        font-weight:700;
        color:#fff;
    }
    .wrapper{
        position: relative;
        /*height: calc(100% - 93px);*/
        height: 580px;
        /*background-color: red;*/
        overflow: hidden;
        /*overflow: hidden;*/
    }
</style>